// Gyroscope parallax state. Values are -1..1, smoothed, mirrored to CSS vars
// (--tilt-x / --tilt-y) so layout layers can follow the phone's tilt.
export const tilt = { x: 0, y: 0, enabled: false };

const SESSION_KEY = "tilt_choice";
let base = null;

const clamp = (v) => Math.max(-1, Math.min(1, v));

export const isTouchDevice = () => window.matchMedia("(pointer: coarse)").matches;
export const tiltSupported = () => typeof window.DeviceOrientationEvent !== "undefined";
export const tiltNeedsPermission = () =>
  tiltSupported() && typeof window.DeviceOrientationEvent.requestPermission === "function";
export const tiltChoice = () => sessionStorage.getItem(SESSION_KEY);
export const rememberTiltChoice = (v) => sessionStorage.setItem(SESSION_KEY, v);

function onOrientation(e) {
  if (e.gamma == null || e.beta == null) return;
  if (!base) base = { g: e.gamma, b: e.beta };
  const tx = clamp((e.gamma - base.g) / 22);
  const ty = clamp((e.beta - base.b) / 22);
  tilt.x += (tx - tilt.x) * 0.18;
  tilt.y += (ty - tilt.y) * 0.18;
  const root = document.documentElement.style;
  root.setProperty("--tilt-x", tilt.x.toFixed(3));
  root.setProperty("--tilt-y", tilt.y.toFixed(3));
}

export async function enableTilt() {
  if (!tiltSupported()) return false;
  if (tiltNeedsPermission()) {
    try {
      const res = await window.DeviceOrientationEvent.requestPermission();
      if (res !== "granted") return false;
    } catch {
      return false;
    }
  }
  if (!tilt.enabled) {
    window.addEventListener("deviceorientation", onOrientation, { passive: true });
    document.documentElement.classList.add("tilt-on");
    tilt.enabled = true;
  }
  return true;
}
